module.exports = __webpack_public_path__ + "img/13.57323ad7.jpg";